import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { makeSetStoreField } from '@hh.ru/redux-create-reducer/lib/createReducer';

import { useResumeSearchCount } from 'src/components/Search/Common/Filters/hooks/draft/useResumeSearchCount';
import { useSelector } from 'src/hooks/useSelector';
import { setSearchDraftClustersOrder } from 'src/models/search/common/clustersOrder/draft';
import { setSearchDraftCount } from 'src/models/search/common/draft';
import {
    setSearchGeoDrawerOpened,
    CurrentGeoFilter,
    setSearchGeoDrawerCurrentFilter,
} from 'src/models/search/common/geoDrawer';
import { ClusterKey } from 'src/types/search/common/clusters';

import { useGeoFiltersMetroRedesignExp } from 'src/components/Search/Resume/Filters/Geo/hooks/useGeoFiltersRedesignExp';

const searchDraftClustersAction = makeSetStoreField('searchDraftClusters');

export const useOpenGeoDrawer = () => {
    const dispatch = useDispatch();

    const isGeoFiltersMetroRedesignExp = useGeoFiltersMetroRedesignExp();
    const metroCities = useSelector((state) => state.metroCities);
    const clusters = useSelector((state) => state.searchClusters);
    const order = useSelector((state) => state.searchClustersOrder);
    const count = useResumeSearchCount();
    const selectedAreaId = clusters[ClusterKey.Area]?.selectedValues?.[0] || '';
    const isOnlyOneAreaSelected = clusters[ClusterKey.Area]?.selectedValues?.length === 1;
    const citiesDistricts = useSelector((state) => state.citiesDistricts);
    const isDistrictsAvailable = selectedAreaId in citiesDistricts;
    const isMetroAvailable =
        isGeoFiltersMetroRedesignExp && metroCities.includes(String(clusters[ClusterKey.Area]?.selectedValues?.[0]));

    let secondStepActiveFilter = null;
    if (isOnlyOneAreaSelected && isMetroAvailable) {
        secondStepActiveFilter = CurrentGeoFilter.METRO;
    } else if (isOnlyOneAreaSelected && isDistrictsAvailable) {
        secondStepActiveFilter = CurrentGeoFilter.DISTRICT;
    }

    return useCallback(
        (specificFilter?: CurrentGeoFilter) => {
            dispatch([
                searchDraftClustersAction(clusters),
                setSearchDraftClustersOrder(order),
                setSearchDraftCount(count),
                setSearchGeoDrawerOpened(),
                setSearchGeoDrawerCurrentFilter(
                    secondStepActiveFilter !== null ? specificFilter || secondStepActiveFilter : CurrentGeoFilter.AREA
                ),
            ]);
        },
        [dispatch, clusters, order, count, secondStepActiveFilter]
    );
};
